$('.product-hero .slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    appendArrows: '.product-hero .slider .arrows',
    slide: '.product-hero .slide',
    autoplay: false
});

$('.product-hero .more').on('click', function (e) {
    e.preventDefault();
    $.scrollTo('#tabs', 750, {
        offset: {
            top: -100
        }
    });
});

$('.product-hero .btn').on('click', function (e) {
    e.preventDefault();
    $.scrollTo('#enquiry', 750);
});

$('[data-toggle="tooltip"]').tooltip();
